import _classCallCheck from "/home/runner/work/deckdeckgo/deckdeckgo/site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/deckdeckgo/deckdeckgo/site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _asyncToGenerator from "/home/runner/work/deckdeckgo/deckdeckgo/site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/deckdeckgo/deckdeckgo/site/node_modules/@babel/runtime/regenerator/index.js";
import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-44720cc3.js';
function s() {
  return window ? window.matchMedia("(any-pointer:coarse)").matches : !1;
}
function i(o, e) {
  var t = o.querySelectorAll(e),
    n = o.shadowRoot ? o.shadowRoot.querySelectorAll(e) : [];
  return Array.from(t).concat(Array.from(n));
}
function a(o, e) {
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
      var n, r;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              n = [], r = i(o, e);
              _context.t0 = r && r.length > 0;
              if (!_context.t0) {
                _context.next = 7;
                break;
              }
              r.forEach(function (m) {
                n.push(m.lazyLoadContent());
              });
              _context.next = 6;
              return Promise.all(n);
            case 6:
              t();
            case 7:
              t();
            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
}
function l(o) {
  return new Promise(function (e) {
    if (!o) {
      e();
      return;
    }
    o.forEach(function (t) {
      t.hasAttribute("data-src") && (t.setAttribute("src", "".concat(t.getAttribute("data-src"))), t.removeAttribute("data-src"), t.classList.contains("deckgo-reveal") || t.style.setProperty("visibility", "inherit")), t.style.setProperty("pointer-events", "none");
    }), e();
  });
}
function d(o) {
  return new Promise(function (e) {
    if (!o) {
      e();
      return;
    }
    o.forEach( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return t.lazyLoad();
              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()), e();
  });
}
function c(o) {
  return new Promise( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
      var t;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              t = [];
              t.push(u(o));
              t.push(f(o));
              _context3.next = 5;
              return Promise.all(t);
            case 5:
              e();
            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }());
}
function u(o) {
  return new Promise( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e) {
      var t;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              t = i(o, "img");
              _context4.next = 3;
              return l(t);
            case 3:
              e();
            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }());
}
function f(o) {
  return new Promise( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e) {
      var t;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              t = i(o, "deckgo-lazy-img");
              _context5.next = 3;
              return d(t);
            case 3:
              e();
            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }());
}
function P(o) {
  return new Promise(function (e) {
    var t = i(o, "img");
    t && (t = t.filter(function (n) {
      return n.getAttribute("data-src");
    }), t.forEach(function (n) {
      n.style.setProperty("visibility", "hidden");
    })), e();
  });
}
function A() {
  return Promise.resolve();
}
function C(_x6) {
  return _C.apply(this, arguments);
}
function _C() {
  _C = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(o) {
    var e;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            e = [];
            e.push(c(o));
            e.push(a(o, "deckgo-gif"));
            e.push(a(o, "deckgo-youtube"));
            e.push(a(o, "deckgo-demo"));
            e.push(a(o, "deckgo-word-cloud"));
            e.push(a(o, "deckgo-markdown"));
            _context10.next = 9;
            return Promise.all(e);
          case 9:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _C.apply(this, arguments);
}
var deckdeckgoSlideAuthorCss = ":host{display:block;position:relative;-webkit-user-select:var(--slide-user-select, none);-moz-user-select:var(--slide-user-select, none);-ms-user-select:var(--slide-user-select, none);user-select:var(--slide-user-select, none);background:var(--background);color:var(--color);height:inherit;z-index:var(--zIndex, 1);--slide-padding-top-default:64px;--slide-padding-end-default:64px;--slide-padding-bottom-default:64px;--slide-padding-start-default:64px}@media screen and (max-width: 1024px){:host{--slide-padding-top-default:32px;--slide-padding-end-default:32px;--slide-padding-bottom-default:32px;--slide-padding-start-default:32px}}div.deckgo-slide{display:flex;overflow:var(--overflow, hidden);padding:var(--slide-padding-top, var(--slide-padding-top-default)) var(--slide-padding-end, var(--slide-padding-end-default)) var(--slide-padding-bottom, var(--slide-padding-bottom-default)) var(--slide-padding-start, var(--slide-padding-start-default));width:calc( var(--slide-width) - var(--slide-padding-start, var(--slide-padding-start-default)) - var(--slide-padding-end, var(--slide-padding-end-default)) );height:calc( var(--slide-height) - var(--slide-padding-top, var(--slide-padding-top-default)) - var(--slide-padding-bottom, var(--slide-padding-bottom-default)) );min-height:calc( var(--slide-min-height) - var(--slide-padding-top, var(--slide-padding-top-default)) - var(--slide-padding-bottom, var(--slide-padding-bottom-default)) );user-drag:none;-webkit-user-drag:none}@media print{div.deckgo-slide{padding:0;page-break-after:always;height:100vh}::slotted([slot=actions]){display:none}::slotted([slot=background]){display:var(--slide-background-print-display, none)}}::slotted(ul),::slotted(ol){-webkit-padding-start:var(--slide-padding-start, var(--slide-padding-start-default));padding-inline-start:var(--slide-padding-start, var(--slide-padding-start-default))}::slotted([slot=notes]){display:none}::slotted([slot=actions]){position:absolute;top:var(--slide-actions-top, 16px);right:var(--slide-actions-end, 32px);left:var(--slide-actions-start);display:var(--slide-actions-display);z-index:var(--slide-actions-z-index)}::slotted([slot=background]){position:var(--slide-background-position, absolute);top:var(--slide-background-top, 0);right:var(--slide-background-end);left:var(--slide-background-start, 0);width:var(--slide-background-width);height:var(--slide-background-height);z-index:-2;pointer-events:none}::slotted([slot=header]),::slotted([slot=footer]){position:absolute;left:0;width:var(--slide-width);height:100%;display:flex;align-items:center;z-index:var(--slide-header-footer-z-index, -1)}::slotted([slot=header]){top:0;width:calc(var(--slide-width) - var(--slide-header-margin-start, 32px) - var(--slide-header-margin-end, 32px));max-height:var(--slide-header-max-height, 48px);justify-content:var(--slide-header-justify-content, flex-start);margin:var(--slide-header-margin-top, 16px) var(--slide-header-margin-end, 32px) var(--slide-header-margin-bottom, 16px) var(--slide-header-margin-start, 32px)}@media screen and (max-width: 1024px){::slotted([slot=header]){max-height:var(--slide-header-max-height, 16px)}}::slotted([slot=footer]){bottom:0;width:calc(var(--slide-width) - var(--slide-footer-margin-start, 16px) - var(--slide-footer-margin-end, 16px));max-height:var(--slide-footer-max-height, 32px);justify-content:var(--slide-footer-justify-content, center);margin:var(--slide-footer-margin-top, 16px) var(--slide-footer-margin-end, 16px) var(--slide-footer-margin-bottom, 16px) var(--slide-footer-margin-start, 16px)}:host{--slide-actions-z-index:3;--slide-header-footer-z-index:1;--overflow:visible}div.deckgo-slide{flex-flow:row;padding:0;width:var(--slide-width);height:var(--slide-min-height, var(--slide-height))}div.deckgo-slide-author{width:50%;display:flex;align-items:var(--slide-author-align, inherit);text-align:var(--slide-author-text-align, inherit);padding:var(--slide-author-padding-top, var(--slide-padding-top-default)) var(--slide-author-padding-end, var(--slide-padding-end-default)) var(--slide-author-padding-bottom, var(--slide-padding-bottom-default)) var(--slide-author-padding-start, var(--slide-padding-start-default))}div.deckgo-slide-author.deckgo-slide-author-start{background:var(--slide-author-background-start);color:var(--slide-author-color-start);justify-content:center;align-items:center;position:relative}div.deckgo-slide-author.deckgo-slide-author-start img{border-radius:50%;width:var(--slide-author-img-size, 80%);border:var(--slide-author-img-border)}div.deckgo-slide-author.deckgo-slide-author-start.deckgo-slide-author-none{display:none}div.deckgo-slide-author.deckgo-slide-author-start.deckgo-slide-author-cover:before{content:\"\";width:100%;height:var(--slide-height);top:0;left:0;position:absolute;background-image:var(--slide-author-color-start-img-url);background-repeat:no-repeat;background-size:cover}div.deckgo-slide-author.deckgo-slide-author-start.deckgo-slide-author-cover.deckgo-slide-author-mobile:before{background-position:center}div.deckgo-slide-author.deckgo-slide-author-end{background:var(--slide-author-background-end);color:var(--slide-author-color-end);flex-direction:column;justify-content:center}div.deckgo-slide-author.deckgo-slide-author-end.deckgo-slide-author-none{width:100%}div.deckgo-slide-author.deckgo-slide-author-end div.deckgo-slide-author-social{display:flex;align-items:center;justify-content:flex-start;flex-wrap:wrap;padding-top:var(--slide-author-social-padding-top, var(--slide-padding-top-default))}@media (min-width: 992px){div.deckgo-slide-author.deckgo-slide-author-start{width:calc(100% / 3 * 1)}div.deckgo-slide-author.deckgo-slide-author-end{width:calc(100% / 3 * 2)}}@media screen and (max-width: 768px){div.deckgo-slide-author.deckgo-slide-author-start{padding-right:var(--slide-author-padding-end, 0)}}::slotted([slot=title]){display:none}::slotted([slot=social-link]){padding:var(--slide-author-social-link-padding, 8px);max-width:100%}::slotted([slot=title]),::slotted([slot=author]),::slotted([slot=social-link]){z-index:2;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}";
var DeckdeckgoSlideAuthor = /*#__PURE__*/function () {
  function DeckdeckgoSlideAuthor(hostRef) {
    _classCallCheck(this, DeckdeckgoSlideAuthor);
    registerInstance(this, hostRef);
    this.slideDidLoad = createEvent(this, "slideDidLoad", 7);
    /**
     * The design to be applied to the image. cover fits the image to the start pane, circle displays it in a circle and none in case you would not like to display an image
     */
    this.imgMode = 'cover';
    this.mobile = false;
    this.isLazyLoaded = false;
    this.lazyLoadAfterUpdate = false;
    /**
     * If you define a background for the all deck but, a specific one for this slide, set this option to true
     */
    this.customBackground = false;
    /**
     * If you provide actions for the all deck but, a specific one for this slide, set this option to true
     */
    this.customActions = false;
  }
  _createClass(DeckdeckgoSlideAuthor, [{
    key: "componentWillLoad",
    value: function componentWillLoad() {
      this.mobile = s();
    }
  }, {
    key: "componentDidLoad",
    value: function () {
      var _componentDidLoad = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return P(this.el);
              case 2:
                this.slideDidLoad.emit();
              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
      function componentDidLoad() {
        return _componentDidLoad.apply(this, arguments);
      }
      return componentDidLoad;
    }()
  }, {
    key: "onPropChanges",
    value: function () {
      var _onPropChanges = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.lazyLoadAfterUpdate = true;
              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
      function onPropChanges() {
        return _onPropChanges.apply(this, arguments);
      }
      return onPropChanges;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!this.lazyLoadAfterUpdate) {
                  _context8.next = 4;
                  break;
                }
                _context8.next = 3;
                return this.lazyLoadContent();
              case 3:
                this.lazyLoadAfterUpdate = false;
              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
      function componentDidUpdate() {
        return _componentDidUpdate.apply(this, arguments);
      }
      return componentDidUpdate;
    }()
  }, {
    key: "beforeSwipe",
    value: function beforeSwipe(_enter, _reveal) {
      return new Promise(function (resolve) {
        resolve(true);
      });
    }
  }, {
    key: "afterSwipe",
    value: function afterSwipe() {
      return A();
    }
  }, {
    key: "lazyLoadContent",
    value: function lazyLoadContent() {
      var _this = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(resolve) {
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.next = 2;
                  return C(_this.el);
                case 2:
                  _this.isLazyLoaded = true;
                  resolve();
                case 4:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        }));
        return function (_x7) {
          return _ref6.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "revealContent",
    value: function revealContent() {
      return Promise.resolve();
    }
  }, {
    key: "hideContent",
    value: function hideContent() {
      return Promise.resolve();
    }
  }, {
    key: "render",
    value: function render() {
      var classAuthorStart = "deckgo-slide-author deckgo-slide-author-start deckgo-slide-author-".concat(this.imgMode, " ").concat(this.mobile ? 'deckgo-slide-author-mobile' : '');
      var classAuthorEnd = "deckgo-slide-author deckgo-slide-author-end deckgo-slide-author-".concat(this.imgMode, " ").concat(this.mobile ? 'deckgo-slide-author-mobile' : '');
      return h(Host, {
        class: {
          'deckgo-slide-container': true
        }
      }, h("div", {
        class: "deckgo-slide"
      }, h("slot", {
        name: "title"
      }), h("div", {
        class: classAuthorStart,
        style: {
          '--slide-author-color-start-img-url': this.isLazyLoaded ? "url(".concat(this.imgSrc, ")") : undefined
        }
      }, this.renderImage()), h("div", {
        class: classAuthorEnd
      }, h("slot", {
        name: "author"
      }), h("div", {
        class: "deckgo-slide-author-social"
      }, h("slot", {
        name: "social-link"
      }), h("slot", {
        name: "social-link"
      }), h("slot", {
        name: "social-link"
      }), h("slot", {
        name: "social-link"
      }), h("slot", {
        name: "social-link"
      }), h("slot", {
        name: "social-link"
      }))), h("slot", {
        name: "notes"
      }), h("slot", {
        name: "actions"
      }), h("slot", {
        name: "background"
      }), h("slot", {
        name: "header"
      }), h("slot", {
        name: "footer"
      })));
    }
  }, {
    key: "renderImage",
    value: function renderImage() {
      if (this.imgMode === 'cover' || this.imgMode === 'none') {
        return undefined;
      }
      return h("img", {
        "data-src": this.imgSrc,
        alt: this.imgAlt
      });
    }
  }, {
    key: "el",
    get: function get() {
      return getElement(this);
    }
  }], [{
    key: "watchers",
    get: function get() {
      return {
        "imgMode": ["onPropChanges"]
      };
    }
  }]);
  return DeckdeckgoSlideAuthor;
}();
DeckdeckgoSlideAuthor.style = deckdeckgoSlideAuthorCss;
export { DeckdeckgoSlideAuthor as deckgo_slide_author };